class DetailsModal extends HTMLElement {
  _isOpen = false;
  _onBodyClickEvent = null;

  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    // this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    this._isOpen = value;
    if (value) {
      this.detailsContainer?.setAttribute('open', '');
    } else {
      this.detailsContainer?.removeAttribute('open');
    }
  }

  get detailsContainer() {
    return this.querySelector('details');
  }

  get summaryToggle() {
    return this.querySelector('summary');
  }

  get closeButton() {
    return this.querySelector('button[type="button"]');
  }

  connectedCallback() {
    this.setupEventListeners();
    this.summaryToggle?.setAttribute('role', 'button');
    this.isOpen = this.detailsContainer?.hasAttribute('open') || false;
  }

  setupEventListeners() {
    this.detailsContainer?.addEventListener('keyup', this.handleEscape.bind(this));
    this.summaryToggle?.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
  }

  handleEscape(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  onSummaryClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.isOpen ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const isNavSummaryTarget = event.target.closest('details-disclosure');
    const isHeaderDrawer = event.target.closest('header-drawer');
    // Only handle clicks on page-overlay
    if (!event.target.classList.contains('page-overlay') && !isNavSummaryTarget && !isHeaderDrawer) return;

    setTimeout(() => {
      this.close(isNavSummaryTarget);
    }, 0);
  }

  open(event) {
    // Remove event.stopPropagation()
    this._onBodyClickEvent = this.onBodyClick.bind(this);
    this.isOpen = true;

    // Use setTimeout to avoid immediate trigger
    setTimeout(() => {
      document.body.addEventListener('click', this._onBodyClickEvent);
    }, 0);

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('details-open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  removeEventListeners() {
    if (this._onBodyClickEvent) {
      document.body.removeEventListener('click', this._onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('details-open');
      this._onBodyClickEvent = null;
    }
  }

  close(focusToggle = true) {
    if (!focusToggle) {
      document.activeElement.blur();
    }
    this.isOpen = false;
    this.removeEventListeners(); // This now safely handles the event listener cleanup
  }
}

customElements.define('details-modal', DetailsModal);
